/* ==========================================================================
   ANIME CRUSH — HOMEPAGE CAROUSELS   (owner request 2026-11-02)

   Two kinds, one file, no library:

     [data-ac-carousel="rail"]  a native scroll-snap row (News, Shop by category).
                                It already swipes and scrolls with no script; this
                                adds the arrows and a gentle autoplay that steps
                                one card at a time and wraps at the end.
     [data-ac-carousel="fade"]  stacked slides, one shown (Recommends, Classics).
                                Adds arrows, a counter and the autoplay, and loads
                                each slide's image (data-src) just before it shows.

   Autoplay every data-ac-interval ms (5000: owner, 2026-11-03, "sa dea next"
   after 5 seconds). It PAUSES while keyboard focus is inside the carousel, while
   the tab is hidden and while the carousel is off screen. Under
   prefers-reduced-motion it still advances, but with NO movement: a rail jumps
   one card (scroll behaviour auto) and a fade band swaps at once (ac-home.css
   drops the crossfade). Windows' "animation effects: off" sets that preference,
   and it must not leave the owner's bands frozen. Without JavaScript a rail
   still scrolls and a fade band shows its first slide, so nothing is lost.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadImg(slide) {
    if (!slide) return;
    var imgs = slide.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].src = imgs[i].getAttribute('data-src');
      imgs[i].removeAttribute('data-src');
    }
  }

  function setup(root) {
    if (root.__acCarousel) return;
    root.__acCarousel = true;

    var mode = root.getAttribute('data-ac-carousel');
    var track = root.querySelector('[data-ac-track]');
    var nav = root.querySelector('[data-ac-nav]');
    var prev = root.querySelector('[data-ac-prev]');
    var next = root.querySelector('[data-ac-next]');
    var count = root.querySelector('[data-ac-count]');
    /* the owner's cadence is 5 s: data-ac-interval may make a band faster, never slower */
    var interval = Math.min(parseInt(root.getAttribute('data-ac-interval'), 10) || 5000, 5000);
    if (!track) return;

    var hovering = false, focused = false, visible = true, timer = null;
    var go;

    if (mode === 'fade') {
      var slides = track.querySelectorAll('[data-ac-slide]');
      if (slides.length < 2) return;
      var index = 0;
      go = function (n) {
        var to = (n + slides.length) % slides.length;
        if (to === index) return;
        slides[index].classList.remove('is-active');
        slides[index].setAttribute('aria-hidden', 'true');
        loadImg(slides[to]);
        slides[to].classList.add('is-active');
        slides[to].removeAttribute('aria-hidden');
        index = to;
        if (count) count.textContent = (index + 1) + ' / ' + slides.length;
        /* warm the next frame so the following change has no blank image */
        loadImg(slides[(index + 1) % slides.length]);
      };
      var step = function (d) { go(index + d); };
      loadImg(slides[1]);
    } else {
      var items = track.children;
      if (items.length < 2) return;
      var stepSize = function () {
        var a = items[0].getBoundingClientRect();
        var b = items[1].getBoundingClientRect();
        return Math.max(1, Math.round(b.left - a.left));
      };
      var step = function (d) {
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 2) return;
        var s = stepSize();
        var target;
        if (d > 0) target = track.scrollLeft >= max - 4 ? 0 : Math.min(max, track.scrollLeft + s);
        else target = track.scrollLeft <= 4 ? max : Math.max(0, track.scrollLeft - s);
        track.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
      };
      var syncNav = function () {
        /* everything already fits: no arrows, nothing to rotate */
        if (nav) nav.hidden = track.scrollWidth - track.clientWidth <= 2;
      };
      syncNav();
      window.addEventListener('resize', syncNav);
    }

    if (nav && mode === 'fade') nav.hidden = false;

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (hovering || focused || !visible || document.hidden) return;
      timer = setInterval(function () { step(1); }, interval);
    }

    if (prev) prev.addEventListener('click', function () { step(-1); start(); });
    if (next) next.addEventListener('click', function () { step(1); start(); });

    /* NO PAUSE ON HOVER (owner, 2026-11-03: the carousels move every 5 seconds).
       A mouse resting on the band used to freeze it, and a clicked arrow kept
       focus and stopped the autoplay for good. Only keyboard focus pauses now. */
    root.addEventListener('focusin', function (e) {
      var t = e.target;
      var kb = false;
      try { kb = t && t.matches && t.matches(':focus-visible'); } catch (x) { kb = false; }
      if (kb) { focused = true; stop(); }
    });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) { focused = false; start(); }
    });
    /* a finger on the rail is the reader taking over: wait a full interval */
    track.addEventListener('touchstart', function () { stop(); }, { passive: true });
    track.addEventListener('touchend', function () { start(); }, { passive: true });
    document.addEventListener('visibilitychange', start);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        start();
      }, { threshold: 0.25 }).observe(root);
    } else {
      start();
    }
  }

  function boot() {
    var all = document.querySelectorAll('[data-ac-carousel]');
    for (var i = 0; i < all.length; i++) setup(all[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
